import { Optional, OptionalAny, OptionalArray, OptionalBoolean, OptionalNumber, OptionalObject, OptionalString } from "../types/optional";
import { BLANK, EMPTY_ARRAY, EMPTY_OBJ } from "../constants";


//contacts
export const email = (arg: string): string => `mailto:${arg}`
export const tel = (num: string): string => `tel:${num}`
export const sms = (num: string): string => `sms:${num}`
export const whatsapp = (num: string): string => `https://api.whatsapp.com/send?phone=${num}`

// strings
export const camelToTitle = (text: string): string => {
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}

// array
export const range = (start: number = 0, end: number = 0, step: number = 1): number[] => {
    const ret = []
    for (let i = start; i < end; i += step) ret.push(i)
    return ret
}

// optionals 
export const optional = <T>(arg: Optional<T>, fallback: T): T => arg || fallback
export const optionalAny = (arg: OptionalAny, fallback: any): any => optional(arg, fallback)
export const optionalObject = (arg: OptionalObject, fallback: Object = EMPTY_OBJ): Object => optional<Object>(arg, fallback)
export const optionalArray = <T>(arg: OptionalArray<T>, fallback: T[] = EMPTY_ARRAY): T[] => optional<T[]>(arg, fallback)
export const optionalNumber = (arg: OptionalNumber, fallback: number = 1): number => optional<number>(arg, fallback)
export const optionalBoolean = (arg: OptionalBoolean, fallback: boolean = true): boolean => optional<boolean>(arg, fallback)
export const optionalString = (arg: OptionalString, fallback: string = BLANK): string => optional<string>(arg, fallback)

// update states
export const updateState = <T>(state: Optional<T>, key: string, value: any): OptionalObject => (optionalObject({ ...state, [`${key}`]: value }))

//other
export const blankClick = (): void => { }

// dates
const getMonthIndex = (month: string): OptionalNumber => ({
    "January": 1,
    "Febuary": 2,
    "March": 3,
    "April": 4,
    "May": 5,
    "June": 6,
    "July": 7,
    "August": 8,
    "September": 9,
    "October": 10,
    "November": 11,
    "December": 12,
}[month])

type TimeFrame = { years: number, months: number }

const subtractTime = (start: TimeFrame, end: TimeFrame): TimeFrame => {
    if (end.months < start.months)
        return {
            years: (end.years - 1) - start.years,
            months: 13 + end.months - start.months
        }
    return {
        years: end.years - start.years,
        months: end.months - start.months + 1
    }
}

const getTimeFrame = (start: string, end: string): TimeFrame => {
    const [sMonth, sYear] = start.split(" ")
    const [eMonth, eYear] = end.split(" ")
    const endYear = Number(eYear) || new Date().getFullYear()
    const startYear = Number(sYear)
    const endMonth = Number(getMonthIndex(eMonth)) || new Date().getMonth() + 1
    const startMonth = Number(getMonthIndex(sMonth))
    const { years, months } = subtractTime(
        { years: startYear, months: startMonth },
        { years: endYear, months: endMonth })
    return { years, months }
}

export const getTimeFrameString = (start: string, end: string): string => {
    const { years, months } = getTimeFrame(start, end)
    const YEARS = (y: number): string => y > 1 ? "years" : (y === 1 ? "year" : "")
    const MONTHS = (m: number): string => m > 1 ? "months" : (m === 1 ? "month" : "")
    const RET = (y: number, m: number): string => `${y >0 ?y:""} ${YEARS(y)} ${m > 0? m: ""} ${MONTHS(m)}`.trim()
    const WRAP = (arg:any): string =>`(${arg})`
    if (months >= 12)
        return WRAP(RET(years + 1, months - 12).trim())
    return WRAP(RET(years, months).trim())
}
